import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
  APP_INITIALIZER
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { NZ_DATE_LOCALE, provideNzI18n, pt_BR } from 'ng-zorro-antd/i18n';
import { ptBR } from 'date-fns/locale';
import { registerLocaleData } from '@angular/common';
import pt from '@angular/common/locales/pt';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { loadingInterceptor } from './core/loading/interceptors/loading.interceptor';
import { i18nInitializer } from './core/i18n/i18n.initializer';
import { errorInterceptor } from './core/alerts/interceptors/error.interceptors';
import { telaUrlInterceptor } from './core/interceptors/tela-url.interceptor';
import { autenticacaoInterceptor } from './core/auth/interceptors/autenticacao.interceptor';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { icons } from './core/icons/icons-provider';
import { provideNzConfig } from 'ng-zorro-antd/core/config';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { gerenteProblemDetailsInterceptor } from './features/gerentes/services/gerente-problem-details.interceptor';

registerLocaleData(pt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideNzI18n(pt_BR),
    // Faz o nz-date-picker interpretar datas digitadas conforme o nzFormat (ex.: dd/MM/yyyy) via date-fns.
    { provide: NZ_DATE_LOCALE, useValue: ptBR },
    provideNzIcons(icons),
    provideNzConfig({
      theme: {
        primaryColor: '#019edd'
      }
    }),
    provideEnvironmentNgxMask(),
    importProvidersFrom(FormsModule),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([
        loadingInterceptor,
        autenticacaoInterceptor,
        errorInterceptor,
        telaUrlInterceptor,
        gerenteProblemDetailsInterceptor
      ])
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: i18nInitializer,
      multi: true
    }
  ]
};